export const TABLE_COLUMNS = [
  'name',
  'nda',
  'fileAccess',
  'chat',
  'notes',
  'stage',
  'lastSeen',
  'company',
  'added',
  'context',
  'email',
  'phone',
  'referrer',
  'delete',
] as const;

export type LeadsTableColumnsKey = typeof TABLE_COLUMNS[number];

export const SORTING_VALUES: Partial<
  Record<typeof TABLE_COLUMNS[number], string>
> = {
  stage: 'stageIndex',
  name: 'sortName',
  nda: 'ndaIndex',
  fileAccess: 'numberOfAccessableDocuments',
  chat: 'chatSort',
  lastSeen: 'lastSeen',
  notes: 'notesSort',
  company: 'company',
  referrer: 'referrerSortName',
  added: 'createdAt',
  email: 'email',
  phone: 'phone',
};

export const CUSTOM_COL_SIZES: Partial<
  Record<typeof TABLE_COLUMNS[number], number>
> = {
  name: 210,
  chat: 100,
  notes: 80,
  delete: 80,
  nda: 150,
  fileAccess: 400,
  context: 200,
  phone: 180,
  email: 200,
};

export const SUPER_ADMIN_COLUMNS = ['email', 'phone', 'referrer', 'delete'];

export const REQUIRED_COLUMNS = ['name'];
